import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import Sidebar from './sidebar';
import ScrollAnimation from 'react-animate-on-scroll';

class NEETDetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="course-single-area pd-top-60 pd-bottom-110">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-8">
		        <div className="event-detaila-inner">
		          {/* <div className="thumb mb-4">
		            <img src={publicUrl+"assets/img/other/5.png"} alt="img" />
		          </div> */}
				  <ScrollAnimation animateIn="fadeInRight">
				  <h1 style={{fontSize: '30px'}}>Best NEET Coaching in Kodambakkam, Chennai</h1><br/>
				  <p>“Achieve your dreams with the best <b> NEET coaching in Chennai!</b>”</p><br/>
				  <p>Are you a budding medical aspirant aiming to reach the stars? The NEET (National Entrance cum Eligibility Test) Entrance Exam is the door for you. Conducted by the NTA (National Testing Agency), NEET-UG is an entrance exam for all undergraduate medical, dental, and AYUSH courses approved and recognised in India. As a common entrance exam to MBBS [medicine and surgery], BDS [dental], BAMS [Ayurveda], BSMS [Siddha], BUMS [Unani], and BHMS [Homeopathy], it is conducted once a year with the eligibility criteria as follows:</p><br/>
                  <p><b>Qualifications:</b> 10+2 (or equivalent) with Physics, Chemistry, Biology/Biotechnology & English as core subjects from a recognized board.</p>
				 <p><b>Eligibility Marks (to appear for NEET):</b> Aggregate for PCB: 50% (General), 45% (PWD), 40% (OBC/SC/ST)</p>
				 <br/>
				 <p>Affordable <b> NEET coaching fees in Chennai?</b> We offer NEET coaching in Chennai at a reasonable cost, without compromising on quality. Because every student deserves the opportunity to achieve their dreams.</p>
				 <br/>
				 <p>How does MIET, the best <b> NEET coaching centre in Chennai</b> help you crack NEET?</p><br/>
				 <p>NEET can be overpowering at times, but MIET, the best <b> NEET coaching center in Chennai,</b> helps you crack the basics quickly to give you the competitive edge you need. Our coaching institute offers expert guidance for NEET classes in Chennai and support to help you excel in your NEET exams and secure your future in the medical field.</p>
				
                  </ScrollAnimation>
                  <ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
                        <h5 className="mb-0 mt-2">MIET Chennai best NEETcoaching centre - Stay on top of the syllabus</h5><br/>
                       
							{/* <p>NEET can be overpowering at times, but at MIET we help you crack the basics in no time to give you the competitive edge you need.</p> */}
							
							<ul className="single-list-wrap">
								{/* <li className="single-list-inner style-check">
									<i className="fa fa-check" /> Stay on top of the syllabus
								</li> */}
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />  NEET-specific study materials
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /> Realistic Timelines for courses
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />  Regular revision & doubt clearance classes
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />  Mock tests to help you prepare for D-day.
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />  Separate batches for tamil medium students
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />  Low fee structure with EMI options
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />  Hostel facilities.
								</li>
                                {/* <b>Not just theory, we help you gain practical skills too!</b> */}
							</ul>
						</blockquote>
					</div>
					</ScrollAnimation>
				  
					<ScrollAnimation animateIn="fadeInRight">
						
					<p>To suit your needs and aspirations, at MIET, the best<b> NEET coaching classes in Chennai,</b> we have structured courses and schedules to help aid in competitive development.</p>
					<br/>
					<h5 className="mb-0 mt-2">MIET - NEET exam coaching centre in Chennai</h5><br/>
					<table>
						<tr>
							<th>Course</th>
							<th>Course Duration</th>
							<th>Eligibility</th>
						</tr>
						<tr>
							<td>Foundation Course</td>
							<td>1 Years</td>
							<td>Class 9th, 10th</td>
						</tr>
						<tr>
							<td>Integrated Programme</td>
							<td>2 Years</td>
							<td>Class 11th </td>
						</tr>
						<tr>
							<td>Year-long course</td>
							<td>2 Years</td>
							<td>Class 11th, 12th, Repeaters</td>
						</tr>
					</table><br/>
                    <p><b>Mode of Classes:</b>      Offline, Online & Hybrid</p>
                    <p><b>Batches: </b>		Regular, Evening & Weekend available.</p><br/>
					<p>MIET, gives the <b> best NEET coaching in Chennai,</b> our experienced teachers and comprehensive curriculum are designed to ensure success for all our students. Join us on this journey to achieve your dreams.</p>
                   
					</ScrollAnimation><br/>
                    <ScrollAnimation animateIn="fadeInRight">
						<h5 className="mb-0 mt-2">Practice is the key: Crash Course</h5><br/>
						<p>To help our students ace their NEET exam, MIET,<b> NEET academy in Chennai</b> also offers crash courses to help you revise all the important and key topics that can help you get an excellent score. We are proud to notify you that we have restarted our crash course for NEET from May 2022 and our students have secured a resultful score as per the results declared on 8th September 2022.</p><br/>
						<p>If you are interested in pursuing a career in medicine, MIET offers quality <b> NEET coaching in Chennai</b> at affordable fees. Take advantage of this opportunity to achieve your goals. </p>
					</ScrollAnimation><br/>
                    <ScrollAnimation animateIn="fadeInRight">
						<h5 className="mb-0 mt-2">We don’t give up: Repeaters Batch</h5><br/>
						<p><i>"When you have a dream, you've got to grab it and never let go."</i> &nbsp;  MIET, the <b> best NEET coaching in Chennai</b> helps everyone realize their dream with a year-long repeater’s batch that will help you strengthen your basics and concepts, and instil in you the confidence to build your dream.</p><br/>
						<p>Contact MIET, the<b> NEET coaching institute in Chennai</b> today to learn more and start your journey towards success.</p>
					</ScrollAnimation>
					<ScrollAnimation animateIn="fadeInRight">
				  	<div className='blog-details-page-content'>
					<blockquote>
						<h5 className="mb-0 mt-2">Application Form:</h5><br/>
						<Link to="/online-payment"><button className="btn btn-base" style={{color:'white',fontWeight:'700'}}>Visit</button></Link>
					</blockquote>
					</div>
					</ScrollAnimation>
				  </div>
		      </div>
			  <Sidebar courseRestriction="NEET" />
		    </div>
		  </div>
		</div>

        }
}

export default NEETDetails